import { Link } from "react-router-dom";
import { KineticLines, Overline } from "@/components/motion";
import { motion } from "framer-motion";

const ComingSoon = ({ title, overline, description, image, testId }) => (
  <section data-testid={testId} className="relative min-h-screen flex items-center overflow-hidden">
    <div className="absolute inset-0">
      <img src={image} alt="" className="w-full h-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/70 via-[#050505]/85 to-[#050505]" />
    </div>
    <div className="relative z-10 w-full px-6 md:px-12 lg:px-24 py-40">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.1 }}>
        <Overline>{overline}</Overline>
      </motion.div>
      <KineticLines
        lines={title}
        className="mt-6 font-display uppercase text-7xl sm:text-8xl lg:text-[10vw] leading-[0.85] tracking-tight"
      />
      <KineticLines
        lines={[<span key="avenir" className="text-stroke-gold">À VENIR</span>]}
        baseDelay={0.5}
        className="font-display uppercase text-6xl sm:text-7xl lg:text-[8vw] leading-[0.85] tracking-tight"
      />
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.9 }}
        className="mt-8 max-w-xl text-white/60 text-base md:text-lg leading-relaxed"
      >
        {description}
      </motion.p>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 1.05 }}
        className="mt-10 flex flex-wrap gap-4"
      >
        <Link
          to="/contact?objet=%C3%8Atre%20inform%C3%A9%20du%20lancement"
          data-testid="comingsoon-notify-cta"
          className="px-8 py-4 bg-rouge text-white text-sm font-bold uppercase tracking-[0.15em] rounded-full hover:bg-rouge-hover hover:scale-[1.02] active:scale-95 transition-all shadow-[0_0_20px_rgba(230,0,0,0.3)]"
        >
          Être informé du lancement
        </Link>
        <Link
          to="/"
          data-testid="comingsoon-home-cta"
          className="px-8 py-4 border border-white/20 text-white text-sm font-medium uppercase tracking-[0.15em] rounded-full hover:border-white hover:bg-white/5 transition-all"
        >
          Retour à l'accueil
        </Link>
      </motion.div>
    </div>
  </section>
);

export default ComingSoon;
